const API_ORIGIN = (process.env.REACT_APP_API_ORIGIN || 'https://loansalary.in/lms').replace(
  /\/$/,
  ''
);

const isLocalDevHost = () => {
  if (typeof window === 'undefined') return process.env.NODE_ENV === 'development';
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
};

/**
 * Always hit /lms APIs.
 * Localhost: same-origin relative path (setupProxy → loansalary.in/lms)
 * Production: absolute https://loansalary.in/lms/...
 * 
 */

export const taskApiUrl = (endpoint) => {
  const path = `Api/TaskApi/${String(endpoint).replace(/^\//, '')}`;
  if (isLocalDevHost()) return `/${path}`;
  return `${API_ORIGIN}/${path}`;
};

export const taskApiDirectUrl = (endpoint) =>
  `${API_ORIGIN}/Api/TaskApi/${String(endpoint).replace(/^\//, '')}`;

export const taskApiPostUrl = (endpoint) => taskApiUrl(endpoint);

export const loanBackendUrl = (endpoint) => {
  const path = `loan_backend/${String(endpoint).replace(/^\//, '')}`;
  if (isLocalDevHost()) return `/${path}`;
  return `${API_ORIGIN}/${path}`;
};

export const saveLendingPageUrl = () => taskApiUrl('saveLendingPage');

/** @deprecated kept for imports — same as taskApiUrl */
export const TASK_API_BASE = isLocalDevHost()
  ? '/Api/TaskApi'
  : `${API_ORIGIN}/Api/TaskApi`;

/**
 * Cross Vertical PAN Check
 * Direct API
 */
export const crossVerticalPanUrl = (pan) => {
  const cleanPan = encodeURIComponent(String(pan || '').trim().toUpperCase());
  return `https://dhanwalle.in/checkGetCustomerbyPan/${cleanPan}`;
};

export const formatApiMessage = (message) => {
  if (typeof message !== 'string')
    return 'Something went wrong. Please try again.';

  return message
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<[^>]+>/g, '')
    .trim();
};
